
const clickHandler = event => {
	const el = event.currentTarget
	const sibling = el.nextElementSibling
	const menu = sibling.matches('.site-menu-mobile__children') ? sibling : false
	const isOpen = menu.matches('.is-open')
	if (!menu) return
	if (isOpen) return

	event.preventDefault()
	menu.classList.add('is-open')
}

export default () => {
	const toplevel = [...document.querySelectorAll('.js-mobilemenu-link')]
	toplevel.map(link => link.addEventListener('click', clickHandler))
}